<template>
    <div class="gy-left">
        <router-link to="../guanyu"><p :class="{'p1' : isp1}" class="p"><i class="iconfont">&#xe60e;</i>关于逛球街</p></router-link>
        <router-link to="../guanyu/disclaimer"><p :class="{'p2' : isp2}" class="p"><i class="iconfont">&#xe60f;</i>免责声明</p></router-link>
        <router-link to="../guanyu/contact"><p :class="{'p4' : isp4}" class="p"><i class="iconfont">&#xe6ec;</i>联系方式</p></router-link>
    </div>
</template>


<script>
export default {
    data(){
        return{
            isp1: false,
            isp2: false,
            isp4: false,
        }
    },
    mounted(){
        this.urlFun();
    },
    methods:{
        urlFun(){
            if(window.location.href.indexOf('disclaimer')!='-1'){
             return this.isp2 = true;
            }else if(window.location.href.indexOf('contact')!='-1'){
             return this.isp4 = true;
            }else{
             return this.isp1 = true;
            }
        }
    }    
}

</script>
<style scoped>
	@import "../../assets/css/aboutLeft.css";
</style>
